import React, { useState, useEffect } from 'react';
import ContactForm from '../helper/ContactForm';
import ContactLinks from '../helper/ContactLinks';
import { myBG } from '../helper/constants';

const Contact = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize(); // Check initial width
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section id='contact' style={styles.heading}>
      <h2>Contact</h2>

      {isMobile ? (
        <div style={styles.mainSectionMobile}>
          <ContactForm />

          <ContactLinks />
        </div>
      ) : (
        <div style={styles.mainSection}>
          <ContactForm />

          <ContactLinks />
        </div>
      )}

      <p style={styles.copyright}>© 2023 Vignesh Gunasekaran</p>
    </section>
  );
};

const styles = {
  heading: {
    // marginTop: '10px',
    marginLeft: '5px',
    // marginBottom: '10px',
    marginRight: '5px',
    padding: '20px', // Add some padding to create space around the content
    // background: 'rgba(255, 255, 255, 0.2)', // Use an rgba color for the background with reduced opacity
    background: myBG,
    backdropFilter: 'blur(10px)', // Add a blur effect to create the glass panel effect
    borderRadius: '10px', // Add rounded corners for a better look
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', // Add a subtle shadow for depth
  },
  mainSection: {
    marginLeft: '10px',
    display: 'flex',
    justifyContent: 'left',
    // justifyContent: 'center',
  },
  mainSectionMobile: {
    marginLeft: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  copyright: {
    textAlign: 'center',
  },
};

export default Contact;
